"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rand_1 = require("../rand");
var util_1 = require("../util");
var process_1 = require("../process");
var IGNORED_INPUT_TAILS = [","];
var DEFAULT_TAIL_PROBABILITIES = {
    "!": 0.1,
    "?": 0.09,
    o: 0.07,
    u: 0.06,
    e: 0.03,
    i: 0.03,
    y: 0.03
};
// prettier-ignore
var LENGTHS = [
    2, 2, 2, 2, 2, 2, 2,
    3, 3, 3, 3, 3,
    4, 4, 4,
    5, 5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
exports.repeat = function (input, tailProbabilities) {
    if (tailProbabilities === void 0) { tailProbabilities = DEFAULT_TAIL_PROBABILITIES; }
    if (process_1.isProcessedWord(input)) {
        var _a = __spreadArrays(input).reverse(), tail_1 = _a[0], rest = _a.slice(1);
        if (IGNORED_INPUT_TAILS.includes(tail_1.source)) {
            return input;
        }
        if (Math.random() > (tailProbabilities[tail_1.source] || 0)) {
            return input;
        }
        return __spreadArrays(rest.reverse(), [
            __assign(__assign({}, tail_1), { transformed: __spreadArrays(util_1.times(rand_1.sample(LENGTHS), function () { return tail_1.source; }), tail_1.transformed) })
        ]);
    }
    return input;
};
